import { Box, Typography, useTheme } from '@material-ui/core'
import useGetIsMobileScreen from '../../hooks/useGetIsMobileScreen'
import styles from './VNTotalListItem.module.scss'
import cn from 'classnames'

export const VNTotalListItem = ({
  title,
  amount,
  totalClassName = null,
  titleIcon,
  isCFD = false,
  isHighlighted = false,
  key = null,
}) => {
  const isMobile = useGetIsMobileScreen()
  const theme = useTheme()

  return (
    <Box pb={2} className={styles.total} key={key}>
      <Box className={styles.serviceChargeTotal}>
        <Typography
          style={theme.custom.subtitle3}
          className={cn(
            styles.titleTypography,
            totalClassName,
            { [styles.cfdTitle]: isCFD },
            { [styles.mobileTitle]: isMobile },
            { [styles.highlighted]: isHighlighted },
          )}
        >
          {title}
        </Typography>
        {titleIcon}
      </Box>
      <Typography style={theme.custom.subtitle3} className={cn(totalClassName, { [styles.highlighted]: isHighlighted })}>
        {amount}
      </Typography>
    </Box>
  )
}
